<fgb-banner [pageTitle]="'lotto.page.title' | translate" />
<fgb-page-header [pageTitle]="'featured.rewards.page.title'" [backButtonLink]="'/'" />

<fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>

<div class="container">
  <fgbcl-lottos-list [isList]="true"></fgbcl-lottos-list>
</div>
